import { agriAlertGetStressAlertData } from '@/util/Request/agrialert';
import { IGetStressAlertReqModel } from '@/util/Request/agrialert/requestType';
import {
    IAgriAlertTranslateResModel,
    IGetStressAlertDataResModel,
} from '@/util/Request/agrialert/responseType';
import moment, { max } from 'moment';
import React, { useEffect, useMemo, useState } from 'react';
import { getWeekTranslate } from '../../initData';
import './index.less';
import { lowerCaseFirstLetter } from '@/util/commonFunction';
import IF from '@/components/IF';

interface IProp {
  showStressAlert: boolean;
  allStressAlertReq: IGetStressAlertReqModel[];
  translateValue: IAgriAlertTranslateResModel;
  languageCode: string;
}



const TemplateStressAlert = (prop: IProp) => {
    const { showStressAlert, allStressAlertReq, translateValue, languageCode } =
    prop;

    const finalFormat = languageCode === 'fr' ? 'DD/MM' : 'MM/DD';

    const [currentStressAlertReqData, setCurrentStressAlertReqData] = useState<IGetStressAlertDataResModel[][]>([]);
    const [forecastStressAlertData, setForecastStressAlertData] = useState<IGetStressAlertDataResModel[]>([]);
    const [historicalStressAlertData, setHistoricalStressAlertData] = useState<IGetStressAlertDataResModel[]>([]);
    const [mixedStressAlertData, setMixedStressAlertData] = useState<IGetStressAlertDataResModel[]>([]);
    const [maxForecastDateArray, setMaxForecastDateArray] = useState<string[]>([]);
    const [maxMixDateArray, setMaxMixDateArray] = useState<string[]>([]);
    const [currentMixedToday,setCurrentMixedToday] = useState<string>(null);

    const [repeatRequest, setRepeatRequest] = useState<string[]>([]);

    const mergedStressAlertReq = useMemo(() => {
        const repeatEntries: string[] = []; // 临时存储重复项

        const result = allStressAlertReq.reduce((acc, current) => {
            const existingGroup = acc.find((item) => item.groupId === current.groupId);

            if (existingGroup) {
                const riskList = existingGroup.stressAlertType.split(';');
                if (riskList.includes(current.stressAlertType)) {
                // 收集重复条目
                    const duplicateEntry = `${current.stressAlertType}#${current.startDate}#${current.endDate}`;
                    repeatEntries.push(duplicateEntry);
                } else {
                // 拼接新的 diseaseRisk
                    existingGroup.stressAlertType += `;${current.stressAlertType}`;
                }
            } else {
            // 添加新项
                acc.push({ ...current });
            }

            return acc;
        }, [] as IGetStressAlertReqModel[]);

        // 统一更新 repeatRequest（仅收集到新重复项时才更新）
        setRepeatRequest(repeatEntries);

        return result;
    }, [allStressAlertReq]); // 仅在这两个依赖变化时重新执行

    // const mergedStressAlertReq = allStressAlertReq.reduce((acc, current) => {
    //     const existingGroup = acc.find((item) => item.groupId === current.groupId);

    //     if (existingGroup) {
    //         // 如果已经存在相同的 groupId，则拼接 StressAlertReq
    //         existingGroup.stressAlertType += `;${current.stressAlertType}`;
    //     } else {
    //         // 如果不存在相同的 groupId，则添加新的项
    //         acc.push({ ...current });
    //     }

    //     return acc;
    // }, [] as IGetStressAlertReqModel[]);

    // get stress alert data
    const getStressAlertListDataFunc = async () => {
        try {
            // 创建一个数组来存储所有的 promise
            const promises = mergedStressAlertReq?.map(async (item) => {
                return getStressAlertDataFuc(item);
            });

            // 使用 Promise.all 等待所有的 promise 完成
            const results = await Promise.all(promises);

            console.log('All stress alert data result:', results);
            setCurrentStressAlertReqData(results);

            return results; // 返回所有结果
        } catch (error) {
            console.error('Failed to get stress alert data, error is: ', error);
            return null;
        }
    };

    const getStressAlertDataFuc = async (
        requestModel: IGetStressAlertReqModel
    ) => {
        try {
            const res = await agriAlertGetStressAlertData(requestModel);
            // translate the week name
            // const format = languageCode === 'fr' ? 'DD/MM/YYYY' : 'MM/DD/YYYY';
            if (res?.data?.length >= 1) {
                res?.data?.forEach((item, itemIndex) => {
                    res.data[itemIndex].backColors = [];
                    item?.date?.forEach((dateItem, dateIndex) => {
                        // const dayOfWeek = moment(dateItem, format)?.day();
                        const dayOfWeek = item?.weeks?.[dateIndex]?.weekIndex;
                        res.data[itemIndex].date[dateIndex] =
                            dateItem + ' ' + getWeekTranslate(translateValue, dayOfWeek); // set backColor
                        res.data[itemIndex].backColors[dateIndex] =
                        item?.values?.[dateIndex] === '1'
                            ? 'rgb(238, 26, 26)'
                            : 'rgb(65, 195, 4)';
                    });

                    // change for model name translate
                    // for crop name translate
                    const tmpModelId = lowerCaseFirstLetter(item?.modelId);
                    res.data[itemIndex].modelName = translateValue?.[tmpModelId];
                });
            }
            return res?.data;
        } catch (error) {
            return null;
            console.log('get disease risk data failed, error is ', error);
        }
    };

    useEffect(() => {
        if (showStressAlert && translateValue) {
            getStressAlertListDataFunc();
        }
    }, [showStressAlert, translateValue]);


    const classifyDataByFirstDate = (data: IGetStressAlertDataResModel[][]) => {
        const currentDate = moment().startOf('day'); // 获取当前日期（去掉时间部分）
        const historicalArray = []; // 存储历史数据
        const futureArray = []; // 存储未来数据

        const mixedData = [];
        // filter for mixed value
        const uniqueGroupIdForMixed = Array.from(new Set(allStressAlertReq?.map(item => item.groupIdForMixed)
            ?.filter((value): value is string => value !== undefined)));
        console.log('lanxue change uniqueGroupIdForMixed',uniqueGroupIdForMixed);

        // for forecast and historical group
        data.forEach((group) => {
            group.forEach((item) => {
                const firstDateStr = item?.originDate?.[0]?.split(' ')[0]; // 提取第一个日期部分
                if (!firstDateStr) {
                    console.error('Invalid date array:', item);
                    return;
                }

                const firstDate = moment(firstDateStr, 'YYYY-MM-DD', true); // 使用严格模式解析日期
                if (!firstDate.isValid()) {
                    console.error('Invalid first date:', firstDateStr, 'in item:', item);
                    return;
                }

                // 判断第一个日期是否小于当前日期
                if (firstDate.isBefore(currentDate, 'day')) {
                    historicalArray.push(item); // 归类为历史数据
                } else {
                    futureArray.push(item); // 归类为未来数据
                }
            });
        });

        // process repeat request
        repeatRequest.forEach((item) => {
            const [modelId, startDate,endDate] = item.split('#');
            const tmpFutureItem = futureArray.find((futureItem) =>
                futureItem.modelId === modelId &&
                futureItem.originDate?.[0] === startDate &&
                futureItem.originDate?.[futureItem.originDate?.length - 1] === endDate);
            const tmpHistoricalItem = historicalArray.find((historicalItem) =>
                historicalItem.modelId === modelId &&
                historicalItem.originDate?.[0] === startDate &&
                historicalItem.originDate?.[historicalItem.originDate?.length - 1] === endDate);
            if(tmpFutureItem){
                futureArray.push(tmpFutureItem);
            }
            if(tmpHistoricalItem){
                historicalArray.push(tmpHistoricalItem);
            }
        });

        const mixedFutureIndex = [];
        const mixedHistoricalIndex = [];

        let maxForecastDate = [];
        let maxHistoricalDate = [];
        uniqueGroupIdForMixed?.forEach((item) => {
            // const groutKeyData = item?.split('-');
            const [historicalDaysStr, forecastDaysStr, modelId] = item.split('-');
            if (!historicalDaysStr || !forecastDaysStr || !modelId) {
                console.warn(`Invalid groupId format: ${item}`);
                return;
            }
            let tmpFutureItem:IGetStressAlertDataResModel = null;
            let tmpHistoricalItem:IGetStressAlertDataResModel = null;
            // for future
            for (let itemIndex = 0; futureArray && itemIndex < futureArray.length; itemIndex++) {
                const item = futureArray[itemIndex];
                if (item.modelId === modelId &&
                    item?.date?.length === Number(forecastDaysStr) &&
                    !(mixedFutureIndex?.includes(itemIndex))
                ) {
                    tmpFutureItem = item;
                    mixedFutureIndex.push(itemIndex);
                    break; // 找到后立即退出循环
                }
            }
            // futureArray?.forEach((item, itemIndex) => {
            //     if (item.modelId === modelId && item?.date?.length === Number(forecastDaysStr)) {
            //         tmpFutureItem = item;
            //         mixedFutureIndex.push(itemIndex);
            //         return;
            //     }
            // });
            // for historical
            for (let itemIndex = 0; historicalArray && itemIndex < historicalArray.length; itemIndex++) {
                const item = historicalArray[itemIndex];
                if (item.modelId === modelId &&
                    item?.date?.length === Number(historicalDaysStr) &&
                    !(mixedHistoricalIndex?.includes(itemIndex))
                ) {
                    tmpHistoricalItem = item;
                    mixedHistoricalIndex.push(itemIndex);
                    break; // 找到后立即退出循环
                }
            }
            // historicalArray?.forEach((item, itemIndex) => {
            //     if (item.modelId === modelId && item?.date?.length === Number(historicalDaysStr)) {
            //         tmpHistoricalItem = item;
            //         mixedHistoricalIndex.push(itemIndex);
            //         return;
            //     }
            // });
            // set for max date
            if(tmpFutureItem?.date?.length > maxForecastDate?.length) {
                maxForecastDate = [...tmpFutureItem.date];
            }
            if(tmpHistoricalItem?.date?.length > maxHistoricalDate?.length) {
                maxHistoricalDate = [...tmpHistoricalItem.date];
            }
            const tmpMixedItem: IGetStressAlertDataResModel = {
                backColors: [...tmpHistoricalItem.backColors,...tmpFutureItem.backColors],
                date: [...tmpHistoricalItem.date,...tmpFutureItem.date],
                modelId: tmpHistoricalItem.modelId,
                modelName: tmpHistoricalItem.modelName,
                values: [...tmpHistoricalItem.values,...tmpFutureItem.values],
                weeks: [...tmpHistoricalItem.weeks,...tmpFutureItem.weeks],
            };
            mixedData.push(tmpMixedItem);
            if(tmpFutureItem?.date?.length >= 1 && currentMixedToday === null) {
                setCurrentMixedToday(tmpFutureItem?.date?.[0]);
            }
        });



        setMixedStressAlertData(mixedData);
        setForecastStressAlertData(futureArray?.filter((_, index) => !mixedFutureIndex?.includes(index)) || []);
        setHistoricalStressAlertData(historicalArray?.filter((_, index) => !mixedHistoricalIndex?.includes(index)) || []);
        setMaxMixDateArray([...maxHistoricalDate, ...maxForecastDate]);
    };

    useEffect(() => {
        const maxDateItem = forecastStressAlertData.reduce((prev, current) => {
            return (current.date?.length || 0) > (prev.date?.length || 0) ? current : prev;
        }, {} as IGetStressAlertDataResModel);

        const maxDates = maxDateItem.date || [];
        setMaxForecastDateArray(maxDates);
    }, [forecastStressAlertData]);

    useEffect(() => {
        const maxDateItem = forecastStressAlertData.reduce((prev, current) => {
            return (current.date?.length || 0) > (prev.date?.length || 0) ? current : prev;
        }, {} as IGetStressAlertDataResModel);

        const maxDates = maxDateItem.date || [];
        setMaxForecastDateArray(maxDates);
    }, [forecastStressAlertData]);

    useEffect(() => {
        if (currentStressAlertReqData?.length >= 1) {
            classifyDataByFirstDate(currentStressAlertReqData);
        }
    }, [currentStressAlertReqData]);

    console.log('lanxue change allStressAlertReq',allStressAlertReq);
    console.log('lanxue change currentStressAlertReqData',currentStressAlertReqData);
    console.log('lanxue change forecastStressAlertData',forecastStressAlertData);
    console.log('lanxue change historicalStressAlertData',historicalStressAlertData);
    console.log('lanxue change mixedStressAlertData',mixedStressAlertData);
    console.log('lanxue change maxMixDateArray',maxMixDateArray);


    return showStressAlert ? (
        <div style={{overflow:'auto'}}>
            {/* Stress Alert For Forecast  */}
            <IF show = {forecastStressAlertData?.length >= 1}>
                <div className="forecast-table content-basic chart-or-table-top disease-table-container">
                    <div className="historical-chart-title common-title">
                        {/* {translateValue?.stress_alert || 'Stress Alert'} */}
                        {(translateValue?.stress_alert || 'Stress Alert')+ ' - ' + (translateValue?.forecast || 'Forecast')}
                    </div>

                    <table
                        // key={`table-${index}-${tableIndex}`}
                        className="daily-table-container"
                    >
                        <thead>
                            <tr>
                                <td></td>
                                {maxForecastDateArray.map((day, dayIndex) => (
                                    <td
                                        key={`day-${dayIndex}`}
                                        style={{
                                            width: `${((822 - 130) / (maxForecastDateArray?.length || 1))}px`,
                                            padding: '3px 0px',
                                        }}
                                    >
                                        {day}
                                    </td>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                forecastStressAlertData?.flat()?.map((item, index) => {
                                    return (
                                        <tr
                                            key={`item-${index}`}
                                        >
                                            <td
                                                style={{
                                                    width: '130px',
                                                }}
                                            >
                                                {item.modelName}
                                            </td>
                                            {/* render detail value */}
                                            {maxForecastDateArray.map((day, dayIndex) => {
                                                const valueIndex = item.date?.findIndex((dateItem) => dateItem === day);
                                                const color = valueIndex !== -1 ? item?.backColors?.[valueIndex] : 'grey';
                                                return(
                                                    <td
                                                        key={`day-${dayIndex}`}
                                                        style={{
                                                            width: `${((822 - 130) / (maxForecastDateArray?.length || 1))}px`,
                                                            height: '30px',
                                                            backgroundColor: `${color}`,
                                                            color: `${color}`,
                                                            boxSizing: 'border-box',
                                                            padding: '3px 0px',
                                                        }}
                                                    >
                                                        {day}
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    );
                                })
                            }
                        </tbody>
                    </table>

                    <div className="new-color-legend" style={{paddingTop: '20px'}}>
                        <table className="color-legend-table">
                            <thead>
                                <tr className="color-first-tr">
                                    <td colSpan={6}>
                                        {translateValue?.color_legend || 'Color Legend'}
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <div
                                            className="square"
                                            style={{ backgroundColor: 'rgb(65, 195, 4)' }}
                                        ></div>
                                    </td>
                                    <td>
                                        <span>{translateValue?.no_stress || 'No Stress'}</span>
                                    </td>
                                    <td>
                                        <div
                                            className="square"
                                            style={{ backgroundColor: 'rgb(238, 26, 26)' }}
                                        ></div>
                                    </td>
                                    <td>
                                        <span>{translateValue?.stress || 'Stress'}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </IF>
            {/* Stress Alert For Historical */}
            <IF show = {historicalStressAlertData?.length >= 1}>
                <div className="forecast-table content-basic chart-or-table-top disease-table-container">
                    <div className="historical-chart-title common-title">
                        {/* {translateValue?.stress_alert || 'Stress Alert'} */}
                        {(translateValue?.stress_alert || 'Stress Alert')+ ' - ' + (translateValue?.historical || 'Historical')}
                    </div>

                    {historicalStressAlertData?.flat()?.map((item, index) => {
                    // 计算需要多少个表格，每个表格最多7个数据点
                        const tableCount = Math.ceil(item.values.length / 7);

                        // 创建一个辅助函数用于将数组分块
                        const chunkArray = (array, size) =>
                            Array.from({ length: Math.ceil(array.length / size) }, (v, i) =>
                                array.slice(i * size, i * size + size)
                            );

                        // 分割日期和值数组为多个长度为7的小数组
                        const dateChunks = chunkArray(item.date, 7);
                        const valueChunks = chunkArray(item.values, 7);
                        const colorChunks = chunkArray(item?.backColors, 7);

                        // 提取计算td宽度的逻辑为一个函数，提高代码复用性和可读性
                        const calculateTdWidth = () => {
                            if (dateChunks.length === 1) {
                                return 822 / (dateChunks[0].length || 1); // 防止除以0，这里做个兜底处理
                            }
                            return 822 / 7;
                        };

                        const tmpWidth = calculateTdWidth();


                        return (
                            <>
                                <div
                                    className="spray-item-name "
                                    style={{ marginTop: '10px', marginBottom: '5px' }}
                                >
                                    {item.modelName}
                                </div>
                                {/* 根据计算出的表格数量渲染相应数量的表格 */}
                                {dateChunks.map((dateChunk, tableIndex) => (
                                    <table
                                        key={`table-${index}-${tableIndex}`}
                                        className="daily-table-container"
                                    >
                                        <thead>
                                            <tr>
                                                {dateChunk.map((day, dayIndex) => (
                                                    <td
                                                        key={`day-${index}-${tableIndex}-${dayIndex}`}
                                                        style={{ width: `${tmpWidth}px` }}
                                                    >
                                                        {day}
                                                    </td>
                                                ))}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                {colorChunks[tableIndex]?.map((value, valueIndex) => (
                                                    <td
                                                        key={`value-${index}-${tableIndex}-${valueIndex}`}
                                                        style={{
                                                            width: `${tmpWidth}px`,
                                                            height: '30px',
                                                            backgroundColor: `${value}`,
                                                        }}
                                                    >
                                                        {/* {value} */}
                                                    </td>
                                                ))}
                                            </tr>
                                        </tbody>
                                    </table>
                                ))}
                            </>
                        );
                    })}

                    <div className="new-color-legend" style={{paddingTop: '20px'}}>
                        <table className="color-legend-table">
                            <thead>
                                <tr className="color-first-tr">
                                    <td colSpan={6}>
                                        {translateValue?.color_legend || 'Color Legend'}
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <div
                                            className="square"
                                            style={{ backgroundColor: 'rgb(65, 195, 4)' }}
                                        ></div>
                                    </td>
                                    <td>
                                        <span>{translateValue?.no_stress || 'No Stress'}</span>
                                    </td>
                                    <td>
                                        <div
                                            className="square"
                                            style={{ backgroundColor: 'rgb(238, 26, 26)' }}
                                        ></div>
                                    </td>
                                    <td>
                                        <span>{translateValue?.stress || 'Stress'}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </IF>

            {/* Stress Alert For Mixed */}
            <IF show = {mixedStressAlertData?.length >= 1}>
                <div className="forecast-table content-basic chart-or-table-top disease-table-container">
                    <div className="historical-chart-title common-title">
                        {/* {translateValue?.stress_alert || 'Stress Alert'} */}
                        {(translateValue?.stress_alert || 'Stress Alert')+ ' - ' + translateValue?.forecast + ' ' + translateValue?.and + ' ' + translateValue?.historical}
                    </div>

                    <table
                        // key={`table-${index}-${tableIndex}`}
                        className="daily-table-container"
                    >
                        <thead>
                            <tr>
                                <td></td>
                                {maxMixDateArray.map((day, dayIndex) => (
                                    <td
                                        key={`day-${dayIndex}`}
                                        style={{
                                            width: `${((822 - 130) / (maxMixDateArray?.length || 1))}px`,
                                            padding: '3px 0px',
                                            fontWeight: `${day === currentMixedToday ? 800 : 400}`,
                                        }}
                                    >
                                        {day}
                                    </td>
                                ))}
                            </tr>
                        </thead>
                        <tbody>
                            {
                                mixedStressAlertData?.flat()?.map((item, index) => {
                                    return (
                                        <tr
                                            key={`item-${index}`}
                                        >
                                            <td
                                                style={{
                                                    width: '130px',
                                                }}
                                            >
                                                {item.modelName}
                                            </td>
                                            {/* render detail value */}
                                            {maxMixDateArray.map((day, dayIndex) => {
                                                const valueIndex = item.date?.findIndex((dateItem) => dateItem === day);
                                                const color = valueIndex !== -1 ? item?.backColors?.[valueIndex] : 'grey';
                                                return(
                                                    <td
                                                        key={`day-${dayIndex}`}
                                                        style={{
                                                            width: `${((822 - 130) / (maxMixDateArray?.length || 1))}px`,
                                                            height: '30px',
                                                            backgroundColor: `${color}`,
                                                            color: `${color}`,
                                                            boxSizing: 'border-box',
                                                            padding: '3px 0px',
                                                        }}
                                                    >
                                                        {day}
                                                    </td>
                                                );
                                            })}
                                        </tr>
                                    );
                                })
                            }
                        </tbody>
                    </table>

                    <div className="new-color-legend" style={{paddingTop: '20px'}}>
                        <table className="color-legend-table">
                            <thead>
                                <tr className="color-first-tr">
                                    <td colSpan={6}>
                                        {translateValue?.color_legend || 'Color Legend'}
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <div
                                            className="square"
                                            style={{ backgroundColor: 'rgb(65, 195, 4)' }}
                                        ></div>
                                    </td>
                                    <td>
                                        <span>{translateValue?.no_stress || 'No Stress'}</span>
                                    </td>
                                    <td>
                                        <div
                                            className="square"
                                            style={{ backgroundColor: 'rgb(238, 26, 26)' }}
                                        ></div>
                                    </td>
                                    <td>
                                        <span>{translateValue?.stress || 'Stress'}</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </IF>
        </div>
    ) : null;
};

export default TemplateStressAlert;
